function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
});

var SvgFacebookRounded = function SvgFacebookRounded(props) {
  return React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "facebook",
    className: "facebook-rounded_svg__svg-inline--fa facebook-rounded_svg__fa-facebook facebook-rounded_svg__fa-w-16",
    viewBox: "0 0 512 512"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook-rounded.62d8b6ef.svg";
export { SvgFacebookRounded as ReactComponent };